<template>
    <form class="module-time-tracker" ref="form">
        <loading-indicator v-if="loading"/>
        <template v-else>
            <form-row label="Mitarbeiter" error-name="employee_id" required>
                <form-select v-model="employee" :options="employees" disabled/>
                <input type="hidden" name="employee_id" v-model="employee">
            </form-row>
            <hr>
            <fieldset-cloneable v-model="weeks">
                <template #render="{values, $index, manage}">
                    <div class="infobox infobox-border margin-bottom-5">
                        <div class="flex flex-column">
                            <div class="row flex-vertical-middle">
                                <input type="hidden" :name="'assign_overtime[' + $index + '][id]'" v-model="values.id">
                                <form-row class="col-5" label="Woche wählen" :label-for="'assign_overtime-' + $index + '-week'" :error-name="'assign_overtime.' + $index + '.week'"
                                    filter-name="assign_overtime.week" hide-validator>
                                    <form-input-date v-model="values.start" :name="'assign_overtime[' + $index + '][week]'" type="week" :min="minDate"/>
                                </form-row>

                                <form-row class="col-5" label="Stunden" :label-for="'assign_overtime[' + $index + '][hours]'" :error-name="'assign_overtime.' + $index + '.hours'"
                                    filter-name="assign_overtime.hours">
                                    <form-input v-model="values.allocatedTime" type="text" placeholder="HH:MM, H.H oder H,H" :disabled="!values.variant"/>
                                    <input type="hidden" :name="'assign_overtime[' + $index + '][hours]'" v-model="values.allocatedTime">
                                </form-row>

                                <span v-interact="() => manage.add($index)" class="icon-interact margin-right-2" aria-label="Zeitraum hinzufügen" title="Zeitraum hinzufügen" v-tooltip>
                                      <i aria-hidden="true" class="material-icons text-success">add</i>
                                </span>

                                <span v-interact="() => manage.delete($index)" class="icon-interact" aria-label="Zeitraum entfernen" title="Zeitraum entfernen" v-tooltip>
                                    <i aria-hidden="true" class="material-icons text-danger">delete</i>
                                </span>
                            </div>
                            <form-row v-if="values.weeklyHours" error-name="spacer">
                                <div class="time-tracker-overtime-box" :style="values.weeklyHours >= timeToDecimal(values.allocatedTime) ? 'color: #26a65b': 'color: #d50000'">
                                    {{
                                        values.weeklyHours === timeToDecimal(values.allocatedTime)
                                            ? 'Gesamte Woche wird abgebaut'
                                            : 'Verfügbare Stunden: ' + values.allocatedTime + ' / ' + values.weeklyHours + 'h'
                                    }}
                                </div>
                                <div v-if="values.errors && values.errors.length > 0" class="form-error padding-4">
                                    <p v-for="error of values.errors">{{error}}</p>
                                </div>
                            </form-row>
                            <template v-if="values.weeklyHours !== timeToDecimal(values.allocatedTime)">
                                <form-row label="Art" error-name="spacer">
                                    <div v-for="option in variantOptions($index)">
                                        <label class="flex flex-vertical-middle gap-5 pointer margin-bottom-5">
                                            <form-input-radio v-model="values.variant" :value-on="option.value"/>
                                            <span>{{option.label}}</span>
                                        </label>
                                    </div>
                                </form-row>

                                <form-input :model-value="values.variant === variants($index).chooseDay.value ? 1 : 0" :name="'assign_overtime[' + $index + '][dismantling_coretime]'" type="hidden"/>

                                <template v-if="values.variant === variants($index).chooseDay.value">
                                    <template v-for="(day, dayIndex) of daysInWeek($index)">
                                        <template v-if="values.workDays.includes(day.key)">
                                            <div class="flex gap-5 time-tracker-settings-row">
                                                <form-row hide-validator-icon label="Ganztägig" :class="[{'hide-label': dayIndex}, 'text-center']">
                                                    <div class="input-line-height">
                                                        <form-input-checkbox v-model="values[`${day.key}_absence_all_day`]" :name="`assign_overtime[` + $index + `][${day.key}_absence_all_day]`"/>
                                                    </div>
                                                </form-row>

                                                <form-row :label="day.name + ', ' + dateHelper('d.m.', day.date)" :label-for="`${day.key}_absence`" :error-name="`${day.key}_absence`"
                                                    class="checkbox-label" hide-validator-icon hide-validator>
                                                    <div class="flex time-tracker-settings-row">
                                                        <form-input :model-value="values[`${day.key}_absence_all_day`] || values[`${day.key}_absence_from`] && values[`${day.key}_absence_to`] ? 1 : 0" :name="`assign_overtime[` + $index + `][${day.key}_absence]`" type="hidden"/>

                                                        <form-input-date v-model="values[`${day.key}_absence_from`]" :name="`assign_overtime[` + $index + `][${day.key}_absence_from]`" type="time"
                                                            :disabled="values[`${day.key}_absence_all_day`]" :aria-label="'Absesend am ' + day.name + ' von'"/>
                                                        <form-input-date v-model="values[`${day.key}_absence_to`]" :name="`assign_overtime[` + $index + `][${day.key}_absence_to]`" type="time"
                                                            :disabled="values[`${day.key}_absence_all_day`]" :aria-label="'Absesend am ' + day.name + ' bis'"/>
                                                    </div>
                                                </form-row>

                                                <form-row hide-validator-icon label="Stunden" :class="[{'hide-label': dayIndex}, 'text-center']">
                                                    <div class="input-line-height">{{formatSeconds(getDayWorkHours($index ,day.key))}}</div>
                                                </form-row>
                                            </div>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </div>
                    </div>
                </template>
            </fieldset-cloneable>
            <hr>
            <div class="time-tracker-allocated-time" v-sticky="{position: 'bottom', offset: 100}" >
                <span :style="{color: timeToDecimal(allocatedTime) <= timeToDecimal(remainingOvertime) ? 'green' : 'red'  }">Gesamte Zeit: {{allocatedTime}} / {{remainingOvertime.replace('+', '')}}</span>
            </div>
        </template>
    </form>
</template>

<script lang="ts">
    import FieldsetCloneable from '@/components/FieldsetCloneable.vue';
    import FormError from '@/components/form/FormError.vue';
    import FormInputCheckbox from '@/components/form/FormInputCheckbox.vue';
    import FormInputRadio from '@/components/form/FormInputRadio.vue';
    import {incrementDate, weekDays} from '@/library/date';
    import {toInt} from '@/library/math';
    import {convertDecimalToTimeFormat} from '@/library/modules/time-tracker/overtime';
    import {getSecondsByTimeString} from '@/library/modules/time-tracker/time-tracker';
    import dateHelper from '@/utils/portuna/dateHelper';
    import AbsenceCalendar from '@/views/absences/AbsenceCalendar.vue';
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';
    import FormInput from '../../../components/form/FormInput.vue';
    import FormInputDate from '../../../components/form/FormInputDate.vue';
    import FormRow from '../../../components/form/FormRow.vue';
    import FormSelect from '../../../components/form/FormSelect.vue';
    import FormTextarea from '../../../components/form/FormTextarea.vue';
    import LoadingIndicator from '../../../components/LoadingIndicator.vue';
    import formatSeconds from '../../../filters/formatSeconds';
    import {formSubmit, getFormData, parseFormData} from '../../../library/form';
    import {popupDefaultCancelButton} from '../../../library/popup';
    import TopMessageHandler from '../../../library/topMessageHandler';
    import {errorHandler} from '../../../utils/portuna';

    @Component({
        name: 'AssignOvertimePopup',
        methods: {
            dateHelper,
            formatSeconds},
        components: {
            FormError,
            FormInputRadio,
            FormInputCheckbox,
            AbsenceCalendar,
            FieldsetCloneable,
            LoadingIndicator,
            FormSelect,
            FormTextarea,
            FormInput,
            FormInputDate,
            FormRow
        },
    })
    export default class AssignOvertimePopup extends Vue
    {
        readonly $refs: {
            form: HTMLFormElement,
        };

        @Prop({
            type: Number,
            default: 0,
        }) id: number;

        employee: number = 0;

        type: Nullable<number> = null;

        weeks: WeekEntry[] = [];

        employees: Record<number, string> = {};

        remainingOvertime: string  = '';

        allocatedTime: string  = '';

        remainingColor: string  = '';

        minDate: string  = '';

        loading: boolean = true;

        deactivated = false;

        today = dateHelper('Y-m-d') as string;

        currentWeeks = [];

        @Watch('weeks', {deep: true})
        watchWeeks(newWeeks: WeekEntry[])
        {
            let allocatedTime = 0;
            for (let index = 0; index < newWeeks.length; index++)
            {
                if (!newWeeks[index].variant)
                {
                    newWeeks[index].allocatedTime = formatSeconds(this.getDayWorkHoursSum(index));
                }

                allocatedTime += this.timeToDecimal(newWeeks[index].allocatedTime) || 0;
            }

            this.allocatedTime = convertDecimalToTimeFormat(allocatedTime);

            const newDeactivated = allocatedTime > this.timeToDecimal(this.remainingOvertime);

            if (newDeactivated !== this.deactivated)
            {
                this.deactivated = newDeactivated;
                this.emitter.emit('setButtons', this.buttons);
            }

            const newWeekStarts = newWeeks
                .filter((week) => week.start)
                .map((week) => week.start);

            newWeeks.forEach((newWeek) =>
            {
                if (
                    newWeek.start &&
                    this.currentWeeks.indexOf(newWeek.start) === -1
                )
                {
                    this.currentWeeks.push(newWeek.start);
                    this.fetchWeek(newWeek.start);
                }
            });

            for (let i = this.currentWeeks.length - 1; i >= 0; i--)
            {
                const week = this.currentWeeks[i];
                if (!newWeekStarts.includes(week))
                {
                    this.currentWeeks.splice(i, 1);
                }
            }
        }

        get typeOptions()
        {
            return [
                {
                    value: 0,
                    label: 'Stunden hinzufügen',
                },
                {
                    value: 1,
                    label: 'Stunden abziehen',
                },
            ];
        }

        get buttons()
        {
            const buttons: PopupButton[] = [
                popupDefaultCancelButton,
                {
                    type: 'success',
                    title: 'Stundenabbau anordnen',
                    icon: 'schedule',
                    disabled: this.deactivated,
                    cmd: () => this.post(),
                },
            ];

            return buttons;
        }

        created()
        {
            this.emitter.emit('setButtons', this.buttons);
            this.employee = this.id;
            this.fetch();
        }

        timeToDecimal(time)
        {
            if (time)
            {
                if (typeof time === 'number')
                {
                    return time;
                }

                if (time.indexOf(':') !== -1)
                {
                    const [hours, minutes] = time.split(':').map(Number);

                    const decimalMinutes = minutes / 60;

                    return hours + decimalMinutes;
                }

                return toInt(time);
            }
        }

        variantOptions(index: number): SelectOption[]
        {
            return Object.values(this.variants(index));
        }

        variants(index: number)
        {
            let labelAddition = this.weeks[index].hasCoreTimeSettings ? '(außerhalb der Kernzeit) ' : '';

            return {
                chooseDay: {
                    label: 'Ganzen Arbeitstag oder einzelne Stunden abbauen' ,
                    value: 0,
                },
                hours: {
                    label: `Stunden in der Woche ${labelAddition}abbauen`,
                    value: 1,
                },
            };
        }

        getDayWorkHoursSum(index: number)
        {
            if(!this.weeks[index].workDays){
                return 0;
            }

            let workHoursSum = 0;

            for (const day of this.daysInWeek(index))
            {
                if (!this.weeks[index].workDays.includes(day.key))
                {
                    continue;
                }

                workHoursSum += this.getDayWorkHours(index, day.key);
            }

            return workHoursSum;
        }

        getDayWorkHours(index, dayKey: string): number
        {
            if (this.weeks[index][`${dayKey}_absence_all_day`])
            {
                return this.weeks[index].weekWorkHours[dayKey];
            }

            if (!this.weeks[index][`${dayKey}_absence_from`] || !this.weeks[index][`${dayKey}_absence_to`])
            {
                return 0;
            }

            return getSecondsByTimeString(this.weeks[index][`${dayKey}_absence_to`]) - getSecondsByTimeString(this.weeks[index][`${dayKey}_absence_from`]);
        }

        fetch()
        {
            this.loading = true;
            this.axios.get(`/employee/time-tracker/overtime/fetch-overtime-popup/employee/${this.employee}`)
            .then(({data: { data: r}}) =>
            {
                this.$store.dispatch('form/setFilter', r.filter);
                this.employees         = r.employees;
                this.remainingOvertime = r.remainingOvertime;
                this.remainingColor    = r.remainingColor;
                this.minDate           = r.minDate;

                r.weeks.forEach(week =>
                {
                    week.variant = 1;
                    this.currentWeeks.push(week.start);
                });

                this.weeks             = r.weeks;
                this.loading = false;
                this.emitter.emit('lazy-load-focus');
            })
            .catch((error) =>
            {
                errorHandler(error);
                this.emitter.emit('close');
            });
        }

        fetchWeek(startOfWeek: string)
        {
            this.axios.get(`/employee/time-tracker/overtime/fetch-week/employee/${this.employee}/start-of-week/${startOfWeek}`)
            .then(({data: {data: r}}) =>
            {
                const index       = this.weeks.findIndex(entry => entry.start === r.week.start);
                r.week.variant = 1;
                this.weeks[index] = r.week;
                this.emitter.emit('lazy-load-focus');
            })
            .catch((error) =>
            {
                errorHandler(error);
            });
        }

        daysInWeek(index: number)
        {
            const daysInWeek = weekDays;
            const weekStart = dateHelper('Y-m-d', this.weeks[index].start as string);

            for (let index in daysInWeek)
            {
                if(!daysInWeek.hasOwnProperty(index))
                {
                    continue;
                }

                daysInWeek[index] = Object.assign(daysInWeek[index], {date: dateHelper('Y-m-d', incrementDate(new Date(weekStart as string), parseInt(index)))});
            }

            return (daysInWeek as {key: string, name: string, date: string}[]).filter((day) => day.date >= this.today);
        }

        post()
        {
            let formData = getFormData(this.$refs.form);

            formSubmit(`/employee/time-tracker/overtime/assign-overtime/employee/${this.employee}`, parseFormData(formData))
            .then(() =>
            {
                TopMessageHandler.success(`Der Stundenabbau wurde erfolgreich hinterlegt.`);
                this.emitter.emit('close');
            }).catch((error) =>
            {
                if (error.data.refetch)
                {
                    this.fetch();
                }
                else
                {
                    this.weeks.forEach((week) => {
                        week.errors = [];

                        week.errors = error.data.data.errors
                            .filter((error) => error.week === week.start)
                            .map((error) => error.message);
                    });
                    errorHandler(error);
                }
            });
        }
    }
</script>